import { Head } from "@inertiajs/react";
import { t } from "@travily/i18n";
import { accountSettingsPath, menuPath } from "@travily/routes";
import type { ReactNode } from "react";
import { EditFrame } from "@/layouts/edit-frame";
import PersistentLayout from "@/layouts/persistent-layout";
import { settingsSections } from "./sections";

// Settings has no content of its own: the sections are the content, and each
// carries its own editor.
const AccountSettingsShowPage = () => (
  <>
    <Head title={t("web.accounts.settings.show.meta_title")} />
    <EditFrame
      backHref={menuPath()}
      href={accountSettingsPath()}
      navLayout="row"
      sections={settingsSections()}
      title={t("web.accounts.settings.show.title")}
    />
  </>
);

AccountSettingsShowPage.layout = (page: ReactNode) => <PersistentLayout>{page}</PersistentLayout>;

export default AccountSettingsShowPage;
